import { render, staticRenderFns } from "./FormAlignmentMGHRWC.vue?vue&type=template&id=c5559a2e&scoped=true&"
import script from "./FormAlignmentMGHRWC.vue?vue&type=script&lang=ts&"
export * from "./FormAlignmentMGHRWC.vue?vue&type=script&lang=ts&"
import style0 from "./FormAlignmentMGHRWC.style.scss?vue&type=style&index=0&id=c5559a2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5559a2e",
  null
  
)

export default component.exports